import { useMemo } from "react";
import { usePermissions } from "../../hooks/usePermissions";

export const useHasAdministrationAccess = () => {
  const { hasAccess } = usePermissions();

  const canViewAdministration: boolean = useMemo(() => {
    return (
      hasAccess("FeeTypes", "GetList") &&
      hasAccess("AdministrateLateCharges", "GetList") &&
      hasAccess("AdministrateLateCharges", "GetList") &&
      hasAccess("ImpoundTypes", "GetList") &&
      hasAccess("TicklerTypes", "GetList") &&
      hasAccess("ReportTemplates", "GetList") &&
      hasAccess("FillableFormTemplates", "GetList")
    );
  }, [hasAccess]);

  return { canViewAdministration };
};
